import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ILogin } from '../../interfaces/ILogin';
import { AuthService, IAppLoginApiResponse } from '../../services/auth/auth.service';
import { ToastrServiceManager } from '../../services/toastr/toastr.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  isSubmitting = false;

  loginForm = this.fb.group({
    username: ['', [Validators.required, Validators.email]], // email
    password: ['', [Validators.required, Validators.minLength(4)]],
  });

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrServiceManager
  ) {}

  ngOnInit(): void {
    this.checkIfLoggedIn();
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit(): void {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.toastr.showError('Preencha o formulário corretamente.');
      return;
    }

    const credentials: ILogin = {
      username: this.loginForm.value.username!,
      password: this.loginForm.value.password!,
    };

    this.isSubmitting = true;

    this.authService.login(credentials).subscribe({
      next: (res: IAppLoginApiResponse) => {
        this.isSubmitting = false;

        if (res.status === 'SUCCESS') {
          this.toastr.showSuccess('Login realizado com sucesso.');
          this.router.navigate(['/admin/dashboard']);
        } else {
          const msg =
            res.message ||
            'Falha ao autenticar. Verifique suas credenciais.';
          this.toastr.showError(msg);
        }
      },
      error: (err) => {
        this.isSubmitting = false;
        console.error('[LoginComponent] erro no login:', err);

        const apiMsg = err?.error?.message;
        if (apiMsg) {
          this.toastr.showError(apiMsg);
        } else {
          this.toastr.showError(
            'Não foi possível autenticar. Tente novamente mais tarde.'
          );
        }
      },
    });
  }

  private checkIfLoggedIn(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigate(['/admin/dashboard']);
    }
  }
}
